import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconVivanuncios from '../build/icon-vivanuncios'

export const IconVivanuncios: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconVivanuncios} />
}

export default IconVivanuncios
